<template>
	<div>
		<card xs-tile sm-tile>
			<card-text fill>
				<alert :content="t('view.finisherpoints.store.description')" no-spacing/>
			</card-text>
		</card>
		<data-loader url="/v1/finisherpoints/products" on-scroll guest>
			<template #loading>
				<card v-for="productLoader in 10" :key="'product-loader-' + productLoader">
					<card-text>
						<finisher-points-product-card-skeleton/>
					</card-text>
				</card>
			</template>

			<template v-slot="{data}">
				<card v-for="product in data" :key="'product-' + product.id" xs-tile sm-tile>
					<card-text>
						<finisher-points-product-card :product="product" @purchased="handleProductPurchase"/>
					</card-text>
				</card>
			</template>

			<template #missing>
				<lazy-missing-info :text="t('missing.finisherpoints_product.index')"/>
			</template>
		</data-loader>

	</div>
</template>

<script setup lang="ts">
const {$auth} = useNuxtApp();
const {t} = useI18n();

useMeta({
	title: t('view.finisherpoints.store.title'),
	description: t('view.finisherpoints.store.description')
})

function handleProductPurchase() {
	$auth.fetchUser();
}

</script>

